import React from 'react';
import {IssuesCloseOutlined} from "@ant-design/icons";
import {Popover} from "antd";
import COIN_ICON from "../../pages/icons/coin-icon.png";
import XP_ICON from "../../pages/icons/xp-icon.png";
import NO_IMAGE from "../../pages/icons/no-image-available.png";
import {useTranslation} from "react-i18next";

const AchievementCard = ({achievement}) => {
	const {t} = useTranslation();

	const getPercentFromTwoInts = (a, b) => Math.round((a / b) * 100);

	return (
			<div
					key={achievement.id}
					className="relative border rounded-lg p-4 mb-2 flex items-center justify-between gap-4"
			>
				<div className='flex items-center gap-4'>
					<img
							src={achievement.image ?? NO_IMAGE}
							alt={achievement.title}
							className="w-16 h-16 object-cover rounded-full"
					/>

					<div>
						<h3 className="text-lg font-semibold text-primary">
							{achievement.title}
						</h3>

						<div className='flex items-center gap-4 text-xs font-semibold'>
							<p className='flex items-center gap-0.5'>
								{achievement.reward ?? 0}
								<img className='w-4 h-4 object-contain' src={COIN_ICON} alt="COINS"/>
							</p>
							<p className='flex items-center gap-0.5'>
								{achievement.xp ?? 0}
								<img className='w-4 h-4 object-contain' src={XP_ICON} alt="EXPERIENCE"/>
							</p>
						</div>

						<p className="text-sm text-gray-600">
							{achievement.description}
						</p>
						<small className='block text-xs text-gray-400 leading-none mt-1'>
							{achievement.typeProgress === "percent" ?
									<p>
										{t("achievements.completedOnPercent", {percent: getPercentFromTwoInts(achievement.currentProgress, achievement.maxProgress)})}
									</p>
									:
									<p>
										{achievement.date && (
												<time dateTime={achievement.date}>
													{new Date(achievement.date).toLocaleDateString('ru-RU', {
														day: 'numeric',
														month: 'long',
														year: 'numeric',
													})}
												</time>
										)}
										{' '}
										{t("achievements.completedOnCount", {
											completed: achievement.currentProgress,
											count: achievement.maxProgress
										})}
									</p>
							}
						</small>
					</div>
				</div>

				<Popover
						title={t("achievements.benefits")}
						content={achievement.benefits}
						placement='left'
						overlayClassName='!max-w-[420px] !w-[75%]'
				>
					<IssuesCloseOutlined
							className={`cursor-pointer ${
									achievement.benefits
											? 'text-violet-500'
											: achievement.benefits && (getPercentFromTwoInts(achievement.currentProgress, achievement.maxProgress)) === 100
													? 'text-green-700'
													: 'text-gray-300'
							} ${
									achievement.benefits
											? ''
											: 'pointer-events-none'
							}`}
					/>
				</Popover>

				<span
						className={`absolute h-full top-0 left-0 bottom-0 ${
								getPercentFromTwoInts(achievement.currentProgress, achievement.maxProgress) === 100
										? 'bg-gradient-to-t from-green-600/10 to-green-400/10'
										: 'bg-gradient-to-r from-purple-800/5 to-purple-600/10 rounded-lg'
						} z-[-1] pointer-events-none`}
						style={{
							width: `${getPercentFromTwoInts(achievement.currentProgress, achievement.maxProgress)}%`,
						}}
				/>

			</div>
	);
};

export default AchievementCard;